import { useEffect, useState } from "react";
import ContentLoader from "../../utils/ContentLoader";
import { DatePicker, Modal } from "antd";
import ImagePreviewModal from "../../utils/ImagePreviewModal";
import Select from "react-select";
import { API } from "../../config/constants";
import dayjs from "dayjs";
import { toast } from 'react-toastify';
import { mapEventTypeOptions } from "../../utils/eventTypeUtils";
import { api } from "../../utils/apiClient";
import { Icon } from "@iconify/react/dist/iconify.js";



const { confirm } = Modal;

export default function ImageForm({ onSubmit, onCancel, initialData = {}, }) {
      const isEdit = Boolean(initialData?.id);

      const [loading, setLoading] = useState(false);
      const [errors, setErrors] = useState({});
      const [isAccepted, setIsAccepted] = useState(false);
      const [formData, setFormData] = useState({
            image: null,
            title: "",
            type: ""
      });

      const [preview, setPreview] = useState(null);

      // ------------------ Auto-fill Start/End for new event ------------------
      useEffect(() => {
            if (!initialData || !initialData.id) {
                  const now = dayjs();
            }
      }, [initialData]);

      useEffect(() => {
            if (initialData && initialData.id) {

            }
      }, [initialData]);

      useEffect(() => {
            if (initialData && initialData.id) {
                  setFormData({
                        image: null,
                        title: initialData.title || "",
                        type: initialData.type || ""
                  });

                  if (initialData.url) {
                        setPreview(initialData.url);
                  }
            }
      }, [initialData]);

      const handleChange = (e) => {
            const { name, value, type, files } = e.target;

            if (type === "file") {
                  const file = files[0];

                  setFormData((prev) => ({
                        ...prev,
                        image: file
                  }));

                  if (file) {
                        setPreview(URL.createObjectURL(file));
                  }
            } else {
                  setFormData((prev) => ({
                        ...prev,
                        [name]: value
                  }));
            }

            setErrors((prev) => ({ ...prev, [name]: "" }));
      };

      const updateField = (field, value) => {

            setErrors(prev => ({
                  ...prev,
                  [field]: ""
            }));
      };

      const validate = () => {
            console.log("Inside validate function");
            const newErrors = {};

            if (!formData.image) {
                  newErrors.image = "Image is required";
            }

            if (!formData.type || !formData.type.trim()) {
                  newErrors.type = "Type is required";
            }

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
      };

      const handleSubmit = async (e) => {
            e.preventDefault();

            if (!isEdit && !formData.image) {
                  toast.error("Image is required");
                  return;
            }

            // if (!formData.type?.trim()) {
            //       toast.error("Type is required");
            //       return;
            // }

            // if (!formData.title?.trim()) {
            //       toast.error("Title is required");
            //       return;
            // }

            if (!formData.category?.trim()) {
                  toast.error("Category is required");
                  return;
            }

            try {
                  setLoading(true);

                  const data = new FormData();

                  if (formData.image) {
                        data.append("image", formData.image);
                  }

                  data.append("type", formData.type);
                  data.append("title", formData.title);
                  data.append("category", formData.category || "");

                  let response;

                  if (isEdit) {

                        response = await api.post(`/images/${initialData.id}?_method=PUT`, data, {
                              headers: {
                                    "Content-Type": "multipart/form-data"
                              }
                        });
                  } else {

                        response = await api.post("/images", data, {
                              headers: {
                                    "Content-Type": "multipart/form-data"
                              }
                        });
                  }

                  onSubmit?.(response.data);

            } catch (error) {
                  console.error(error);
            } finally {
                  setLoading(false);
            }
      };


      if (loading) return <ContentLoader />;

      return (
            <div className="col-lg-12">
                  <div className="card mt-3">
                        <div className="card-header">
                              <h5 className="card-title mb-0">{isEdit ? "Edit Image" : "Upload Image"}</h5>
                        </div>

                        <div className="card-body">
                              <form className="row gy-3" onSubmit={handleSubmit} noValidate>
                                    <div className="row gy-3 align-items-end">
                                          <div className="col-md-6">
                                                <label className="form-label">Title<span style={{ color: "red" }}>*</span></label>
                                                <input
                                                      type="text"
                                                      name="title"
                                                      className="form-control"
                                                      value={formData.title}
                                                      onChange={handleChange}
                                                />
                                          </div>
                                          <div className="col-md-6">
                                                <label className="form-label">Type<span style={{ color: "red" }}>*</span></label>
                                                <select
                                                      name="type"
                                                      className="form-control"
                                                      value={formData.type}
                                                      onChange={handleChange}
                                                >
                                                      <option value="">-- Select Type --</option>
                                                      <option value="verses">Verses</option>
                                                      <option value="songs">Songs</option>
                                                      <option value="prayers">Prayers</option>
                                                </select>
                                          </div>
                                          <div className="col-md-6">
                                                <label className="form-label">Category</label>
                                                <select
                                                      name="category"
                                                      className="form-control"
                                                      value={formData.category}
                                                      onChange={handleChange}
                                                >
                                                      <option value="">Select Category</option>
                                                      <option value="மாதா">மாதா</option>
                                                      <option value="இயேசு">இயேசு</option>
                                                      <option value="பரிசுத்த ஆவி">பரிசுத்த ஆவி</option>
                                                      <option value="ஜெபமாலை">ஜெபமாலை</option>
                                                      <option value="சிலுவை">சிலுவை</option>
                                                      <option value="தேவாலயம்">தேவாலயம்</option>
                                                      <option value="திருவிவிலியம்">திருவிவிலியம்</option>
                                                      <option value="இயற்கை">இயற்கை</option>
                                                      <option value="பனி">பனி</option>
                                                      <option value="மெழுகுதிரி">மெழுகுதிரி</option>
                                                      <option value="மலர்">மலர்</option>
                                                      <option value="ஈஸ்டர்">ஈஸ்டர்</option>
                                                      <option value="கிறிஸ்துமஸ்">கிறிஸ்துமஸ்</option>
                                                      <option value="புத்தாண்டு">புத்தாண்டு</option>
                                                </select>
                                          </div>
                                    </div>
                                    <div>
                                          <label className="form-label">Image</label>
                                          <input
                                                type="file"
                                                name="image"
                                                className="form-control"
                                                onChange={handleChange}
                                          />
                                          <div className="mt-3">
                                                {preview && (
                                                      <ImagePreviewModal src={preview} thumbWidth={80} thumbHeight={80} />
                                                )}
                                          </div>
                                    </div>
                                    <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                                          <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={onCancel}
                                          >
                                                Cancel
                                          </button>

                                          <button type="submit" className="btn btn-primary">
                                                {isEdit ? "Update Image" : "Upload Image"}
                                          </button>
                                    </div>
                              </form>
                        </div>
                  </div>
            </div>
      );
}